import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
export var isNumber = function isNumber(number) {
  return typeof number === 'number' && !isNaN(number) || !isNaN(parseFloat(number)) && !isNaN(number - 0) && !number.match(/[A-Za-z]+/);
};